module.exports = __webpack_public_path__ + "img/logo_playStore.f164ef8f.png";